import { useState, useEffect, useCallback } from "react";
import { req_Status } from "./enums";
import { debounce } from "./debounce"; // Import debounce utility

export const useLazySearch = (
  loading,
  optionsName,
  setOptions,
  getData,
  setLoading,
  setTotalPages,
  debounceDelay = 500,
  setIsOpen
) => {
  const fetchOnSearch = async (searchText, page = 1) => {
    if (!getData || loading.status === req_Status.PENDING) return;

    if (setIsOpen) {
      setIsOpen(true);
    }

    setLoading({ status: req_Status.PENDING });

    const res = await getData(page, 5, true, searchText);

    if (res?.status === 200) {
      setOptions((prevOptions) => {
        const newOptions = res.data?.[optionsName] || [];
        const combinedOptions =
          page === 1 ? newOptions : [...prevOptions, ...newOptions];

        return combinedOptions.filter(
          (option, index, self) =>
            index === self.findIndex((o) => o.id === option.id)
        );
      });

      setTotalPages(res.data?.totalPages || 1);
      setLoading({ status: req_Status.SUCCESS });
    } else {
      setLoading({ status: req_Status.FAILED });
    }
  };

  const fetchOptions = useCallback(debounce(fetchOnSearch, debounceDelay), []);

  return { fetchOptions };
};
